import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PhoneInTalkIcon from "@material-ui/icons/PhoneInTalk";
import DialpadIcon from "@material-ui/icons/Dialpad";
import { useWebPhone } from "../../context/WebPhone/WebPhoneContext";

// Aba/chip do webphone no topbar. Aparece enquanto o softphone está ativo
// (registrado) e sobrevive à navegação — clicar expande/recolhe o painel.
const useStyles = makeStyles(theme => ({
  chip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    height: 30,
    padding: "0 11px",
    borderRadius: 8,
    border: `1px solid ${theme.app.border}`,
    background: "#fff",
    cursor: "pointer",
    color: theme.app.ink,
    fontSize: 12.5,
    fontWeight: 500,
    maxWidth: 220,
    "&:hover": { background: theme.app.hover },
  },
  chipOpen: { background: theme.app.dark, borderColor: theme.app.dark, color: "#fff" },
  chipCall: { background: theme.app.ok, borderColor: theme.app.ok, color: "#fff" },
  icon: { fontSize: 16, flexShrink: 0 },
  label: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  sub: { fontFamily: theme.app.mono, fontSize: 11, opacity: 0.8 },
  dot: { width: 7, height: 7, borderRadius: "50%", flexShrink: 0 },
  on: { background: "#37C871" },
  wait: { background: "#E0A92E" },
  off: { background: "#D9534F" },
}));

const WebPhoneChip = () => {
  const classes = useStyles();
  const wp = useWebPhone();
  if (!wp || !wp.visible || !wp.ext) return null;

  const { ext, status, call, minimized } = wp;
  const inCall = call !== "none";
  const expanded = !minimized;

  const statusDot =
    status === "registered" ? classes.on : status === "connecting" ? classes.wait : classes.off;

  const onClick = () => {
    if (expanded) wp.minimize();
    else wp.expand();
  };

  return (
    <div
      className={`${classes.chip} ${inCall ? classes.chipCall : expanded ? classes.chipOpen : ""}`}
      onClick={onClick}
      title={expanded ? "Recolher webphone" : "Abrir webphone"}
    >
      {inCall ? (
        <PhoneInTalkIcon className={classes.icon} />
      ) : (
        <DialpadIcon className={classes.icon} />
      )}
      <span className={classes.label}>{ext.name || ext.sipUsername}</span>
      {inCall ? (
        <span className={classes.sub}>{call === "in-call" ? "em chamada" : call === "incoming" ? "recebendo…" : "chamando…"}</span>
      ) : (
        <span className={`${classes.dot} ${statusDot}`} />
      )}
    </div>
  );
};

export default WebPhoneChip;
